/* Progressive enhancement only: the full store list and contact form work without JS. */
(() => {
  'use strict';
  function init(root) {
    if (root.dataset.d4uReady) return;
    root.dataset.d4uReady = 'true';
    const tools = root.querySelector('[data-d4u-tools]');
    const search = root.querySelector('[data-d4u-search]');
    const cards = [...root.querySelectorAll('[data-d4u-store]')];
    const buttons = [...root.querySelectorAll('[data-d4u-island]')];
    const count = root.querySelector('[data-d4u-count]');
    const empty = root.querySelector('[data-d4u-empty]');
    if (!tools || !search || !count || !empty) return;
    let island = 'all';
    const update = () => {
      const terms = search.value.toLocaleLowerCase('en-NZ').trim().split(/\s+/).filter(Boolean);
      let matches = 0;
      cards.forEach(card => {
        const text = card.dataset.search || '';
        const visible = (island === 'all' || card.dataset.island === island) && terms.every(term => text.includes(term));
        card.hidden = !visible;
        if (visible) matches++;
      });
      count.textContent = `${matches} ${matches === 1 ? 'store' : 'stores'} ${matches === cards.length ? 'to explore' : 'found'}`;
      empty.hidden = matches !== 0;
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.d4uIsland === island)));
    };
    search.addEventListener('input', update);
    search.addEventListener('search', update);
    buttons.forEach(button => button.addEventListener('click', () => {island = button.dataset.d4uIsland; update();}));
    root.querySelector('[data-d4u-reset]')?.addEventListener('click', () => {island = 'all'; search.value = ''; update(); search.focus();});
    tools.hidden = false;
    update();
  }
  const scan = scope => {
    if (scope.matches?.('[data-d4u-stores]')) init(scope);
    scope.querySelectorAll('[data-d4u-stores]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
